module.exports = __webpack_public_path__ + "media/img/super-venue/supervenue-0f9bca327b76ee09d2fc5cccddb18569.png";